import { useState, useEffect, useContext } from 'react';
import { Box, Grid } from '@mui/material';
import { format, parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';
import {
    AppContext,
    SttDialog,
    SttTable,
    SttFormSearch,
} from '../../../sporttia/all';

type Props = {
    open?: boolean;
    facility: any;
    date: string;
    piece: any;
    onClose: () => void;
};

export default function PieceCapacityDialog({
    open = false,
    facility,
    date,
    piece,
    onClose,
}: Props): React.ReactElement {
    const cxt = useContext(AppContext)!;
    const { t } = useTranslation();
    const [occupants, setOccupants] = useState<any>();
    const [name, setName] = useState<string>('');
    const [time, setTime] = useState<string>();

    /**
     * Piece changes
     */
    useEffect(() => {
        if (piece && piece.ini) {
            setTime(format(parseISO(piece.ini), 'H:mm'));
        }
    }, [piece]);

    /**
     * Load occupants
     */
    const loadOccupants = (p = { page: 1, rows: 6 }) => {
        cxt?.api('GET', `/facilities/${facility.id}/bookings/occupants`, {
            params: {
                date,
                name,
                time,
                page: p.page,
                rows: p.rows,
            },
            success: (r: any) => {
                setOccupants(r);
            },
        });
    };

    // Unused function - kept for reference
    // const _toggleConfirmed = (occupant: any) => {
    //     cxt?.api('PUT', `/bookings/occupants/${occupant.id}`, {
    //         params: {
    //             confirmed: !occupant.confirmed,
    //         },
    //         success: (_r: any) => {
    //             setOccupants({
    //                 ...occupants,
    //                 rows: updateElementInArray(occupants.rows, {
    //                     ...occupant,
    //                     confirmed: !occupant.confirmed,
    //                 }),
    //             });
    //         },
    //     });
    // };

    /**
     * Init
     */
    useEffect(() => {
        if (facility && facility.id && time) loadOccupants();
    }, [facility, time]);

    // -----| Render |-----
    return (
        <SttDialog
            fullWidth
            title={t('Seating')}
            open={open}
            onClose={onClose}
            content={
                <>
                    <Box mb={3}>
                        <Grid container spacing={3}>
                            <SttFormSearch
                                {...({
                                    grid: true,
                                    md: 5,
                                    sm: true,
                                    xs: true,
                                    defVal: name,
                                    onChange: ({
                                        value,
                                    }: {
                                        name: string;
                                        value: unknown;
                                    }) => setName(value as string),
                                    onClickSearch: () => loadOccupants(),
                                } as any)}
                            />
                        </Grid>
                    </Box>

                    <SttTable
                        data={occupants}
                        perPage={6}
                        columns={
                            [
                                {
                                    title: t('Name'),
                                    field: 'userName',
                                    align: 'left',
                                    value: (row: any) => row.user?.fullName,
                                },
                            ] as any
                        }
                        onFetch={() => loadOccupants()}
                    />
                </>
            }
            buttons={
                [
                    {
                        type: 'close',
                        onClick: onClose,
                    },
                ] as any
            }
        />
    );
}
